import { useSelectedLanguage } from '../components/Dashboard/Common/Translate/atom';
import 'dayjs/locale/ar';
import 'dayjs/locale/cs';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/el';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/he';
import 'dayjs/locale/hu';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/lt';
import 'dayjs/locale/nl';
import 'dayjs/locale/nn';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import 'dayjs/locale/sv';
import 'dayjs/locale/th';
import 'dayjs/locale/tr';
import 'dayjs/locale/uk';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';

dayjs.extend(LocalizedFormat);

const FNS_LOCALES = {
  it: 'it',
  en: 'en',
  ar: 'ar',
  cs: 'cs',
  da: 'da',
  nl: 'nl',
  gb: 'en',
  us: 'en',
  fi: 'fi',
  fr: 'fr',
  de: 'de',
  el: 'el',
  he: 'he',
  hu: 'hu',
  ja: 'ja',
  ko: 'ko',
  lt: 'lt',
  no: 'nn',
  pl: 'pl',
  pt: 'pt',
  ru: 'ru',
  zh: 'zh-cn',
  es: 'es',
  sv: 'sv',
  th: 'th',
  tw: 'zh-tw',
  tr: 'tr',
  uk: 'uk'
};

type Lang = keyof typeof FNS_LOCALES;

export const useDateFormat = (lang?: string) => {
  const selectedLang = useSelectedLanguage();
  const locale = lang ?? selectedLang;
  return (date: Date | number | string, pattern = 'LL') => {
    try {
      return dayjs(date)
        .locale(FNS_LOCALES[locale.toLowerCase() as Lang])
        .format(pattern);
    } catch {
      return '';
    }
  };
};
